/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { SystemEntitiesSlice } from '../../../../ts/state';
import * as types from './actionTypes';

// only the model changes when enabling and disabling -
// the sysIds are always the same (all)
const sysIds = (
  state: SystemEntitiesSlice['sysIds'] = [],
  action: AnyAction
): SystemEntitiesSlice['sysIds'] => {
  switch (action.type) {
    case types.CREATE_SYSTEM_ENTITY_SUCCESS:
      return [...state];
    case types.FETCH_SYSTEM_ENTITIES_SUCCESS: // OVERWRITE existing sys IDs
      return action.response.result;
    case types.DELETE_SYSTEM_ENTITY_SUCCESS: // DELETE specified sys ID
      return [...state];
    default:
      return state;
  }
};

const INITIAL_PROPS: SystemEntitiesSlice['props'] = {
  loading: false,
  loadingMore: false,
  errorMessage: null
};

// UI specific information
const props = (
  state: SystemEntitiesSlice['props'] = INITIAL_PROPS,
  action: AnyAction
): SystemEntitiesSlice['props'] => {
  switch (action.type) {
    case types.FETCH_SYSTEM_ENTITIES_START:
      return { ...state, loading: true, errorMessage: null };
    case types.DELETE_SYSTEM_ENTITY_START:
      return { ...state, deleting: true, errorMessage: null };
    case types.CREATE_SYSTEM_ENTITY_START:
      return { ...state, creating: true, errorMessage: null };
    case types.FETCH_SYSTEM_ENTITIES_SUCCESS:
      return { ...state, loading: false };
    case types.CREATE_SYSTEM_ENTITY_SUCCESS:
      return { ...state, creating: false };
    case types.DELETE_SYSTEM_ENTITY_SUCCESS:
      return { ...state, deleting: false };
    case types.FETCH_SYSTEM_ENTITIES_ERROR:
    case types.CREATE_SYSTEM_ENTITY_ERROR:
    case types.DELETE_SYSTEM_ENTITY_ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        deleting: false,
        creating: false,
        errorMessage: action.error.error,
        action: action
      };
    default:
      return state;
  }
};

export const reducer = combineReducers({ sysIds, props });

export default reducer;
